/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".awards-and-recognition__image-container[_ngcontent-%COMP%]{display:inline-block}.awards-and-recognition__image[_ngcontent-%COMP%]{height:100px;width:100px;padding:2px}.awards-and-recognition__image-old[_ngcontent-%COMP%]{height:84px;width:100px;padding:2px}.awards-and-recognition__report-image[_ngcontent-%COMP%]{height:100px;width:100px;padding:2px;cursor:pointer}.report-header[_ngcontent-%COMP%]{margin:5px;font-size:14px;border-bottom:1px solid #eae7e6}.awards-and-recognition__message[_ngcontent-%COMP%]{padding:12px 16px;font-size:16px}"];
export { styles as styles };
